// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeEmptyStrings = <T extends Record<string, any>>(
  obj: T,
): Partial<T> => {
  const result: Partial<T> = {};
  for (const key in obj) {
    if (obj[key] !== '') {
      result[key] = obj[key];
    }
  }
  return result;
};
